import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { Dropdown } from "primereact/dropdown";
import SignatureCanvas from "react-signature-canvas";
import dataURLtoBlob from "blueimp-canvas-to-blob";
import axios from "axios";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

export default function RecetasMedicas(props) {
  //const classes = useStyles();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRowMedico, setSelectedRowMedico] = useState(null);
  const [selectedRowPaciente, setSelectedRowPaciente] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [selectedRow, setSelectedRow] = useState(null);

  const steps = ["Médicos", "Residentes"];

  let navigate = useNavigate();
  const buscar = [
    { name: "Nº Documento", code: "N" },
    { name: "Apellido y Nombre", code: "A" },
    { name: "Domicilio", code: "D" },
    { name: "Teléfono", code: "T" },
  ];
  const [medico, guardarMedico] = useState(null);
  const toast = useRef(null);
  const toastWarm = useRef(null);
  const [band, setBand] = useState(true);
  const stepperRef = useRef(null);
  const [buscarPaciente, setBuscarPaciente] = useState(null);
  const [exit, setExit] = useState(false);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    configuracion,
    medicos,
    pacientes,
    medicosRecetas,
    obtenerMedicos,
    obtenerMedicosRecetas,
    obtenerAcceso,
    obtenerPacientes,
    //guardarPacientes,
    setGeriatricoElegido,
    obtenerIngresosEgresos,
  } = serviciosContext;

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "RecetasElectronicas",
      });
    }
  }, [state]);

  useEffect(() => {
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
    });
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    obtenerMedicosRecetas();
    //obtenerDiagnosticosPacientes({ todos: false });
  }, []);

  const exitClick = (e) => {
    navigate(`/`);
  };

  const onHide = (e) => {
    window.location.reload();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const generarReceta = () => {
    if (selectedRowMedico && selectedRow) {
      window.open(
        process.env.REACT_APP_FRONTEND_URL +
          `/generarnuevareceta?medicoId=${selectedRowMedico.id}&pacienteId=${selectedRow.id}`
      );
    } else {
      toast.current.show({
        severity: "info",
        summary: "Receta",
        detail: "Debe seleccionar médico y paciente.",
        life: 3000,
      });
      return;
    }
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Activo</span>
        <Checkbox checked={rowData.active}></Checkbox>
      </Fragment>
    );
  };

  const nombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Apellido y Nombre</span>
        {rowData.nombre}
      </Fragment>
    );
  };

  const domicilioTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Domicilio</span>
        {rowData.domicilio}
      </Fragment>
    );
  };

  const telefonoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Télefono</span>
        {rowData.telefono}
      </Fragment>
    );
  };

  const documentoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nº Documento</span>
        {rowData.numeroDocumento}
      </Fragment>
    );
  };

  const obraSocialTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Obra Social</span>
        {rowData.obrassocialesmedicas
          ? rowData.obrassocialesmedicas.nombre
          : null}
      </Fragment>
    );
  };

  const empresaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Empresa</span>
        {rowData.empresas ? rowData.empresas.nombre : null}
      </Fragment>
    );
  };

  const nacimientoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nacimiento</span>
        {rowData.nacimiento}
      </Fragment>
    );
  };

  const sexoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Sexo</span>
        {rowData.sexo}
      </Fragment>
    );
  };

  const edadTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Edad</span>
        {rowData.nacimiento ? calcularEdad(rowData.nacimiento) : null}
      </Fragment>
    );
  };

  const habilitadoTemplatePaciente = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Habilitado</span>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const calcularEdad = (fecha) => {
    var hoy = new Date();
    var cumpleanos = new Date(fecha);
    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
    var m = hoy.getMonth() - cumpleanos.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }

    return edad;
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Médicos Recetario"></Tag>
      </div>
    </Fragment>
  );

  const headerPacientes = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Dropdown
          value={buscarPaciente}
          onChange={(e) => {
            if (e.value) {
              setBuscarPaciente(e.value);
            } else {
              setBuscarPaciente(null);
              //guardarPacientes([]);
            }
          }}
          options={buscar}
          optionLabel="name"
          showClear
          placeholder="Seleccione una opción de busqueda"
          className="w-full md:w-14rem"
        />

        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Button
          severity="success"
          tooltip="Aceptar"
          icon="pi pi-check"
          onClick={(e) => {
            if (buscarPaciente && globalFilter && globalFilter.length > 0) {
              //obtenerPacientesRecetas({opcion: buscarPaciente,texto: globalFilter,});
            }
          }}
        />
        <Tag value="Pacientes" style={{ marginLeft: "1vw" }}></Tag>
      </div>
    </Fragment>
  );

  //INICIO

  if (medicosRecetas && medicosRecetas.length > 0 && band) {
    setBand(false);
    let local = [];
    for (var i = 0; i < medicosRecetas.length; i++) {
      local.push(medicosRecetas[i]);
    }
    guardarMedico(local);
  }

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === 0 && !selectedRowMedico) {
      toast.current.show({
        severity: "warn",
        summary: "Médicos",
        detail: "Debe seleccionar un médico.",
        life: 3000,
      });
      return;
    }

    if (activeStep === 0 && selectedRowMedico && !selectedRowMedico.active) {
      toast.current.show({
        severity: "warn",
        summary: "Médicos",
        detail: "El médico debe estar activo.",
        life: 3000,
      });
      return;
    }

    if (activeStep === 1 && !selectedRow) {
      toast.current.show({
        severity: "warn",
        summary: "Pacientes",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
      return;
    }

    if (activeStep === 1 && selectedRow && !selectedRow.activo) {
      toast.current.show({
        severity: "warn",
        summary: "Médicos",
        detail: "El residente debe estar activo.",
        life: 3000,
      });
      return;
    }


    if (activeStep === 1) {
      generarReceta()
      return
    }
    

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

    const ingresoEgresoTemplate = (rowData) => {
      return (
        <Fragment>
          <span className="p-column-title">Ingreso/Egreso</span>
          {formatDate(rowData.fechaIngresoEgreso)}
        </Fragment>
      );
    };
  
    const motivoTemplate = (rowData) => {
      return (
        <Fragment>
          <span className="p-column-title">Motivo</span>
          {rowData.motivoIngresoEgreso}
        </Fragment>
      );
    };
  
      const activoTemplate = (rowData) => {
      return (
        <Fragment>
          <span className="p-column-title">Activo</span>
          <Checkbox checked={rowData.activo}></Checkbox>
        </Fragment>
      );
    };
  
    function formatDate(dateString) {
      var allDate = dateString.split("-");
      var newDate = [allDate[2], allDate[1], allDate[0]].join("/");
      return newDate;
    }
  

  //console.log(pacientes);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <Toast ref={toastWarm} position="top-right" />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {medicosRecetas ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  align: "center",
                  margin: "1em",
                  marginTop: "1vw",
                }}
              >
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />

                <Box sx={{ width: "100%" }}>
                  <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      return (
                        <Step key={label} {...stepProps}>
                          <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>

                  <Fragment>
                    {activeStep === 0 ? (
                      <Fragment>
                        <div className="flex flex-column h-12rem">
                          <div className="datatable-responsive-demo">
                            <div className="card">
                              <Tooltip
                                target=".export-buttons>button"
                                position="bottom"
                              />
                              <DataTable
                                value={medicosRecetas}
                                selection={selectedRowMedico}
                                onSelectionChange={(e) =>
                                  setSelectedRowMedico(e.value)
                                }
                                selectionMode="single"
                                dataKey="id"
                                header={header}
                                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                                style={{ fontSize: "small", marginTop: "1vw" }}
                                globalFilter={globalFilter}
                                emptyMessage="No hay datos."
                                paginator
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                rows={100}
                                rowsPerPageOptions={[10, 20, 50, 100]}

                                //paginatorLeft={paginatorLeft}
                                //paginatorRight={paginatorRight}
                              >
                                <Column
                                  field="id"
                                  header="ID"
                                  body={idTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="surname"
                                  header="Apellido"
                                  //body={apellidoTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="name"
                                  header="Nombre"
                                  //body={nombreTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="address"
                                  header="Domicilio"
                                  //body={domicilioTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="workPhone"
                                  header="Teléfono"
                                  //body={telefonoTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="licenseNumber"
                                  header="Matrícula"
                                  //body={mnTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="licenseType"
                                  header="Tipo"
                                  //body={mpTemplate}
                                  sortable
                                ></Column>
                                <Column
                                  field="active"
                                  header="Activo"
                                  body={habilitadoTemplate}
                                  sortable
                                ></Column>
                              </DataTable>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    ) : null}

                    {activeStep === 1 ? (
                      <Fragment>
                        <div className="datatable-responsive-demo">
                          <div className="card">
                            <Tooltip
                              target=".export-buttons>button"
                              position="bottom"
                            />
                            <DataTable
                              value={pacientes}
                              selection={selectedRow}
                              onSelectionChange={(e) => {
                                setSelectedRow(e.value);
                                obtenerIngresosEgresos({
                                  pacienteId: e.value.id,
                                });
                              }}
                              selectionMode="single"
                              dataKey="id"
                              header={header}
                              className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                              style={{ fontSize: "small", marginTop: "1vw" }}
                              globalFilter={globalFilter}
                              emptyMessage="No hay datos."
                              paginator
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                              rows={10}
                              rowsPerPageOptions={[10, 20, 50, 100, 500]}
                              responsiveLayout="scroll"

                              //paginatorLeft={paginatorLeft}
                              //paginatorRight={paginatorRight}
                            >
                              <Column
                                field="id"
                                header="ID"
                                body={idTemplate}
                                sortable
                              ></Column>
                              <Column
                                field="nombre"
                                header="Apellido y Nombre"
                                body={nombreTemplate}
                                style={{ width: "30%" }}
                                sortable
                              ></Column>
                              <Column
                                field="domicilio"
                                header="Domicilio"
                                body={domicilioTemplate}
                                style={{ width: "30%" }}
                                sortable
                              ></Column>
                              <Column
                                field="numeroDocumento"
                                header="Documento"
                                body={documentoTemplate}
                                sortable
                              ></Column>
                              <Column
                                field="fechaIngresoEgreso"
                                header="Ingreso/Egreso"
                                body={ingresoEgresoTemplate}
                                sortable
                              ></Column>
                              <Column
                                field="motivoIngresoEgreso"
                                header="Motivo"
                                body={motivoTemplate}
                                sortable
                              ></Column>
                              <Column
                                field="activo"
                                header="Activo"
                                body={activoTemplate}
                                sortable
                              ></Column>
                            </DataTable>
                          </div>
                        </div>
                      </Fragment>
                    ) : null}

                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Button
                        color="inherit"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                        style={{ marginLeft: "1vw" }}
                      >
                        Anterior
                      </Button>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleNext}>
                        {activeStep === steps.length - 1
                          ? "Receta"
                          : "Siguiente"}
                      </Button>
                    </Box>
                  </Fragment>
                </Box>
              </Grid>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item size={{ xs: 12, md: 12 }}></Grid>
        </Fragment>
      ) : null}
      {exit ? <Navigate to="/login" /> : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
